module.exports = __webpack_public_path__ + "img/introduction-Video-Front-Photo.e3355bd5.jpg";